module.exports = __webpack_public_path__ + "images/_/programs/epsIntermediates/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/images/characters/ian_arms_folded.png
// module id = 870
// module chunks = 2